import MuiTableBody from "@mui/material/TableBody";

export default function TableBody(props) {
  return <MuiTableBody {...props} />;
}
